import { useEffect, useMemo, useRef, useState } from "react";
import { useVeltClient } from "../context";
import { flushSync } from "react-dom";
export function useVeltEventCallback(action) {
    var client = useVeltClient().client;
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(client === null || client === void 0 ? void 0 : client.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = client === null || client === void 0 ? void 0 : client.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            if (memoizedAction === 'initUpdate') {
                flushSync(function () {
                    setData(data);
                });
            }
            else {
                setData(data);
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [client === null || client === void 0 ? void 0 : client.on, memoizedAction]);
    return data;
}
